import { ref, onMounted, onBeforeUnmount } from 'vue'

// Estado compartido entre todas las páginas públicas (no persiste en localStorage
// a propósito: cada visita nueva arranca en claro, sin heredar el modo oscuro
// que el panel admin pudiera tener guardado en el mismo navegador).
const publicTheme = ref('light')

const applyTheme = (value) => {
  document.documentElement.setAttribute('data-theme', value)
}

/**
 * Fuerza modo claro por defecto en una página pública mientras está montada,
 * restaurando el tema previo del documento al desmontar (por si convive con
 * el panel admin en la misma SPA). Devuelve { theme, toggle } para páginas
 * que quieran ofrecer un botón de cambio de tema.
 */
export function usePublicTheme() {
  let previousTheme = null

  onMounted(() => {
    previousTheme = document.documentElement.getAttribute('data-theme')
    applyTheme(publicTheme.value)
  })

  onBeforeUnmount(() => {
    if (previousTheme) document.documentElement.setAttribute('data-theme', previousTheme)
    else document.documentElement.removeAttribute('data-theme')
  })

  const toggle = () => {
    publicTheme.value = publicTheme.value === 'dark' ? 'light' : 'dark'
    applyTheme(publicTheme.value)
  }

  return { theme: publicTheme, toggle }
}
